module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_100_Inactive@1x-201626c323212a5af70dbdb9cf14543c.png";